import { z } from "zod";

const schema = z.object({
  iterations: z.number().int().min(1),
  billingDay: z.number().int().min(1).max(31),
  totalAmountCents: z
    .number()
    .int()
    .min(1, { message: "Monthly retainer is required" })
    .nullable()
    .refine((v) => v !== null, { message: "Monthly retainer is required" }),
  note: z.string().optional(),
});

type Schema = z.infer<typeof schema>;

export { schema as recurringOfferForm, type Schema as RecurringOfferForm };
